import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { AccessTime } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import { DataGrid } from "@mui/x-data-grid";
import CardBody from "components/Card/CardBody.js";
import axios from "axios";
import clsx from "clsx";
import { Grid, Box, Alert } from "@mui/material";
import Moment from "moment";

import successImg from "assets/img/success.gif";
import loaderGif from "assets/img/loading.gif";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function WebHookPayAdmin() {
  const classes = useStyles();
  const [rowsTotal, setRowsTotal] = useState(0);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [remainingTime, setRemainingTime] = useState(0);
  const [returnLogin, setReturnLogin] = React.useState(false);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [state] = useState({
    columns: [
      {
        headerName: "MONTO",
        field: "productsJson",
        flex: 50,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return <b>${params.row.productsJson[0].payTotal}</b>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        hideable: false,
      },
      {
        headerName: "CLIENTE ID",
        field: "clientsTransactionId",
        flex: 50,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        hideable: false,
      },
      {
        headerName: "REFERENCIA",
        field: "reference",
        flex: 50,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        hideable: false,
      },
      {
        headerName: "REQUEST ID PAGO",
        field: "requestIdTransaction",
        flex: 50,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        hideable: false,
      },
      {
        headerName: "Creado",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <span>{Moment(params.value).format("DD-MM-YYYY")} </span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 150,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Estado",
        field: "status",
        // headerAlign: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <Alert
              severity="error"
              icon={false}
              sx={{ fontSize: 10, fontWeight: "bold" }}
            >
              PENDIENTE
            </Alert>
          );
        },
      },
    ],
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // Iniciar la primera consulta
    RefreshTable();
    newSearch();

    // Configuramos el intervalo para hacer la consulta cada 1 segundo
    const intervalId = setInterval(() => {
      newSearch(); // Llamamos a la función de búsqueda cada 1 segundo
    }, 1000);

    // Limpiamos el intervalo cuando el componente se desmonte
    return () => clearInterval(intervalId);
  }, []);

  const newSearch = () => {
    axios
      .get(`${urlServices}clients-transaction/timer/${UserAuth.companyId}`) // Consulta a tu backend
      .then((response) => {
        if (response.status === 200) {
          // Si la consulta es exitosa, procesamos el tiempo restante
          if (response.data.remainingTime === 0) {
            setTimeout(() => {
              setLoader(true);
              RefreshTable();
            }, 2000);
          }
          setRemainingTime(response.data.remainingTime); // Actualizamos el estado con el tiempo restante
        }
      })
      .catch((e) => {});
  };

  const RefreshTable = () => {
    axios
      .get(`${urlServices}clients-transaction/webhook/${UserAuth.companyId}`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          const transformedRows =
            response.data.paymentTransactionsData.data.map((data) => ({
              ...data,
              productsJson: parseJsonArray(
                data.paymentTransactions.productsJson
              ),
            }));

          setRowsTotal(response.data.paymentTransactionsData.total);
          setRows(transformedRows);
          setLoader(false);
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ..."
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setRows([]);
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
      });
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.cardTitleBlack} style={{ fontSize: 18 }}>
          <AccessTime className={classes.iconFilter} /> Resta {remainingTime}{" "}
          para consultar
        </div>
        <Card>
          <CardBody>
            {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      alt="loaderGif"
                      src={loaderGif}
                      style={{ width: 60, margin: "20% 0" }}
                    />
                  </center>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                <Grid container>
                  {rowsTotal > 0 ? (
                    <>
                      <Grid item xs={12} sm={12}>
                        <div
                          className={classes.cardTitleBlack}
                          style={{ fontSize: 22 }}
                        >
                          Notificación
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <Box
                          sx={{
                            "& .super-app.celAll": {
                              fontSize: 12,
                              //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                            },
                            "& .super-app.celActions": {
                              backgroundColor: "rgb(242, 242, 242)",
                            },
                            "& .super-app-theme--header": {
                              backgroundColor: "rgb(242, 242, 242)",
                            },
                            marginTop: 2,
                          }}
                        >
                          <DataGrid
                            rows={rows}
                            columns={state.columns}
                            loading={loader}
                            initialState={{
                              pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                              },
                            }}
                            pageSizeOptions={[5, 10, 20, 50]}
                            disableRowSelectionOnClick={true}
                            checkboxSelection={false}
                            //rowHeight={40}
                            autoHeights
                          />
                        </Box>
                      </Grid>
                    </>
                  ) : (
                    <Grid item xs={12} sm={12} sx={{ padding: "50px 0" }}>
                      <center>
                        <img
                          src={successImg}
                          alt="type"
                          style={{ width: 100, marginBottom: 20 }}
                        />
                        <Alert
                          severity="success"
                          icon={false}
                          sx={{ fontSize: 16, width: 300 }}
                        >
                          PAGOS ACTUALIZADO CON LA PASARELA DE PAGO
                        </Alert>
                      </center>
                    </Grid>
                  )}
                </Grid>
              </Fragment>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
